import React, { useRef, useEffect } from "react";
import { Grid } from "Components/Base/Layout";
import Filter from "./Filter";
import DesktopCourseContent from "./DesktopCourseContent";

const DesktopLayout = ({
  state,
  languageContext,
  resetFilters,
  shouldShowPagination,
  maxPages,
  setPage,
}) => {
  const filterButtonRef = useRef(null);
  const filterContainerRef = useRef(null);
  const previousFilterStateRef = useRef(state.showAdvancedFilter);

  useEffect(() => {
    if (state.showAdvancedFilter && !previousFilterStateRef.current) {
      setTimeout(() => {
        if (filterContainerRef.current) {
          const focusableElements = filterContainerRef.current.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );
          if (focusableElements.length > 0) {
            focusableElements[0].focus();
          } else {
            // Fallback: focus the container itself if it's focusable
            filterContainerRef.current.focus();
          }
        }
      }, 100);
    } else if (!state.showAdvancedFilter && previousFilterStateRef.current) {
      if (filterButtonRef.current) {
        const button = filterButtonRef.current.querySelector("button");
        if (button) {
          button.focus();
        } else {
          filterButtonRef.current.focus();
        }
      }
    }
    previousFilterStateRef.current = state.showAdvancedFilter;
  }, [state.showAdvancedFilter]);

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={12} md={state.showAdvancedFilter ? 9 : 12}>
        <DesktopCourseContent
          state={state}
          languageContext={languageContext}
          resetFilters={resetFilters}
          shouldShowPagination={shouldShowPagination}
          maxPages={maxPages}
          setPage={setPage}
          filterButtonRef={filterButtonRef}
        />
      </Grid>

      {state.showAdvancedFilter && (
        <Grid item xs={12} md={3} sx={{ display: { xs: "none", md: "block" } }}>
          <Filter
            languageContext={languageContext}
            filterContainerRef={filterContainerRef}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default DesktopLayout;
